import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";

export const Route = createFileRoute("/sign-up-success")({
  component: SignUpSuccessPage,
});

function SignUpSuccessPage() {
  return (
    <GlobalShell>
      <div className="flex grow items-center justify-center">
        <div className="card bg-base-100 w-96  shadow-xl max-w-[90vw]">
          <div className="card-body">
            <h2 className="card-title mb-4 text-2xl font-bold">
              Sign Up Successful!
            </h2>
            <p className="mb-6 text-lg">
              Thank you for signing up for SimpleIEP.
            </p>
            <p className="mb-6 text-lg">
              Please check your email for a verification link to complete your
              registration.
            </p>
            <div className="text-sm text-gray-600">
              <p>Didn{"'"}t receive an email?</p>
              <p>
                Check your spam folder or{" "}
                <a
                  href="mailto:hello@simple-iep.com"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  contact us
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </GlobalShell>
  );
}
